"use client"

import { useNftReatom } from "@/app/nft/store/hooks.reatom"
import { BalanceBlockchainScopeProvider } from "@/app/profiles/balance/balance-scope-provider"
import { reatomComponent } from "@reatom/react"
import type { PropsWithChildren } from "react"

export const NftBalanceWrapperReatom = reatomComponent<PropsWithChildren>(
  ({ children }) => {
    const nft = useNftReatom()

    return (
      <BalanceBlockchainScopeProvider blockchain={nft.collection.blockchain}>
        {children}
      </BalanceBlockchainScopeProvider>
    )
  },
)
